import React from 'react';
import { useSurveyStore } from '../../surveyutilities/surveyStore';

function BlockSettingsControl({ block }) {
    const removeQuestion = useSurveyStore((state) => state.removeQuestion);
    const duplicateQuestion = useSurveyStore((state) => state.duplicateQuestion);
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);

    return (
        <div className="ecx-survey-block__footer" onClick={(event) => event.stopPropagation()}>
            <button
                type="button"
                className="btn btn-sm btn-outline-secondary rounded-pill"
                onClick={() => duplicateQuestion(block.internalId)}
            >
                <i className="bi bi-copy me-1" />
                Duplicate
            </button>

            <label className="ecx-survey-props__toggle mb-0">
                <input
                    type="checkbox"
                    className="form-check-input"
                    role="switch"
                    checked={!!block.required}
                    onChange={(event) =>
                        updateQuestion(block.internalId, { required: event.target.checked })
                    }
                />
                <span>Required</span>
            </label>

            <button
                type="button"
                className="btn btn-sm btn-outline-danger rounded-pill"
                onClick={() => removeQuestion(block.internalId)}
            >
                <i className="bi bi-trash me-1" />
                Delete
            </button>
        </div>
    );
}

export default BlockSettingsControl;
